import { LoaderIcon } from '@p2p/assets/svg';
import classNames from 'classnames';

import styles from '../../styles.module.scss';
import innerStyles from './Loader.module.scss';

export const Loader = () => {
  return (
    <div
      className={classNames(
        styles.transfer_dialog,
        styles.transfer_dialog_loader,
        innerStyles.wrapper,
      )}
    >
      <div
        className={classNames(styles.transfer_dialog__body, styles.centered, innerStyles.container)}
      >
        <div className={classNames(styles.transfer_dialog__icon_wr, styles.loader)}>
          <LoaderIcon className={styles.transfer_dialog__icon} />
        </div>
        <div className={styles.transfer_dialog__content}>
          <div className={classNames(styles.transfer_dialog__title, innerStyles.title)}>
            Ожидайте выдачу реквизитов
          </div>
          <div className={styles.transfer_dialog__description}>
            Пожалуйста, не закрывайте страницу
            <br />
            до завершения обработки.
          </div>
        </div>
      </div>
    </div>
  );
};
